<template>
  <div class="card skeleton-card" :style="{ minHeight: height }">
    <div class="card-body" :style="{ padding: padding }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonCard',
  props: {
    height: {
      type: String,
      default: 'auto'
    },
    padding: {
      type: String,
      default: '20px'
    }
  }
}
</script>

<style scoped>
.skeleton-card {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 35px 0 rgb(154 161 171 / 15%);
}
</style>
